

function GenreProgress({ genre, achieved }) {
  const total = 5;
  const percent = (achieved / total) * 100;

  return (
    <div className="mb-2">
      <div className="flex justify-between text-xs mb-1">
        <span>{genre}</span>
        <span className="text-gray-400">
          {achieved} / {total}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <img src="/images/medalla.png" alt="Medalla" className="w-10 h-10" />
        <div className="flex-1 h-3 bg-gray-700 rounded-full border-2 border-white overflow-hidden">
          <div
            className="h-full"
            style={{
              width: `${percent}%`,
              backgroundImage: "url('/images/background1.png')",
              backgroundSize: "cover",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default GenreProgress;